export const TABS_ROUTES = "CPMS_ADMIN_ROUTES";
export const CACHED_TABS_ROUTES = "CACHED_CPMS_ADMIN_ROUTES";

export const TABS_WHITE_LIST = ["Redirect", "login"];

export const CACHED_NOTICE_LIST = "CACHED_NOTICE_LIST";

export const DEFAULTCOUNTLENGTH=12;
export const DEFAULTPRICELENGTH=14;
export const DEFAULTCOUNTMAX=999999999999.99;
export const DEFAULTPRICEMAX=99999999999999.99;
export const DEFAULTTABLEMAXHEIGHT=400;
